export default __webpack_public_path__ + "static/media/logo_ib_fullscreen.802de12c.svg";